// src/hooks/useLoadTawk.js
import { useEffect } from "react";

const useLoadTawk = () => {
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://embed.tawk.to/6788c32b3a842732606ff796/1ihn3kpba";
    script.async = true;
    script.defer = true;
    script.setAttribute("crossorigin", "*");

    // Delay loading to post-interaction (2s)
    const timer = setTimeout(() => {
      document.body.appendChild(script);
    }, 2000);

    return () => clearTimeout(timer);
  }, []);
};

export default useLoadTawk;
